import { ChevronRight } from "lucide-react";

import { useBreadcrumbs } from "@/hooks/useNavRoutes";
import { useRouteStore } from "@/stores/route";

/**
 * Breadcrumb trail từ route hiện tại. Auto-generate qua useBreadcrumbs hook.
 *
 * Empty array → component không render (dùng cho route chat hoặc full-screen
 * editors).
 */
export function Breadcrumbs(): JSX.Element | null {
  const crumbs = useBreadcrumbs();
  const navigate = useRouteStore((s) => s.navigate);

  if (crumbs.length === 0) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className="h-10 px-4 flex items-center gap-1 border-b bg-background/50 text-sm text-muted-foreground shrink-0"
    >
      {crumbs.map((c, i) => (
        <div key={i} className="flex items-center gap-1">
          {i > 0 ? (
            <ChevronRight className="size-3.5 text-muted-foreground/50" aria-hidden />
          ) : null}
          {c.route && i < crumbs.length - 1 ? (
            <button
              type="button"
              onClick={() => navigate(c.route!, c.param)}
              className="hover:text-foreground transition-colors"
            >
              {c.label}
            </button>
          ) : (
            <span
              className={i === crumbs.length - 1 ? "text-foreground font-medium" : ""}
              aria-current={i === crumbs.length - 1 ? "page" : undefined}
            >
              {c.label}
            </span>
          )}
        </div>
      ))}
    </nav>
  );
}
